import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import DropDown from '../DropDown';

function ContentCard({
    heading,
    subHeading,
    showDropDown,
    content,
    dropDownLabel,
    dropDownData,
    dropDownOnClick,
    dropDownVariant,
}) {
    return (
        <div className="content-box">
            <div className="card-header">
                <div className="row">
                    <div className="col">
                        <h2 className="title">{heading}</h2>
                        <p className="desc">{subHeading}</p>
                    </div>
                    {showDropDown ? (
                        <div className="col-5">
                            <DropDown
                                label={dropDownLabel}
                                menuData={dropDownData}
                                onChange={dropDownOnClick}
                                variant={dropDownVariant}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
            {content}
        </div>
    );
}

ContentCard.propTypes = {
    // To display the heading in the card
    heading: PropTypes.string,

    // To display the sub heading in the card
    subHeading: PropTypes.string,

    // Boolean to control if the drop down should be displayed or not
    showDropDown: PropTypes.bool,

    // The content to be rendered in the body of the card
    content: PropTypes.any,

    // Label for the drop down
    dropDownLabel: PropTypes.string,

    // obj to generate the menu items of the drop down
    dropDownData: PropTypes.array,

    // To invoke a function on the press or click of a menu item of the drop down
    dropDownOnClick: PropTypes.func,

    // To select between the variants of drop down for e.g checkbox variant or list variant
    dropDownVariant: PropTypes.string,
};

ContentCard.defaultProps = {
    heading: null,
    subHeading: null,
    showDropDown: false,
    content: null,
};

export default ContentCard;
